module.exports = __webpack_public_path__ + "static/img/barra_13.c708c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_13.png
// module id = oXqU
// module chunks = 1